export default __webpack_public_path__ + "static/swiperCardBg-61809f147f972dedab0274a0344f60d5.png";